export default {
  accessData: 'Dados de acesso',
  activate: 'Ative 60 dias grátis',
  addPrice: '(+R$ ',
  askDependencies1: 'Dependências do Módulo',
  askDependencies2: 'Para utilizá-lo, os módulos abaixo <span style="font-weight:bold">serão adicionados automaticamente</span> ao seu plano:',
  askDependencies3: 'Confirmar inclusão?',
  autonomous: 'Autônomo',
  dependencies: 'Dependências:',
  recommendations: 'Recomendações:',
  description: 'Conheça todos os módulos do Admin Digital e monte o sistema ideal para o seu negócio.',
  enterprise: 'Empresa',
  errors: {
    CONFLICT: 'Não foi possível concluir o cadastro agora. Tente novamente em alguns instantes.',
    COMPANY_DOCUMENT_ALREADY_REGISTERED: 'Esta empresa já possui cadastro. Solicite acesso ao administrador da organização para continuar.',
    EMAIL_EXISTS: 'Este e-mail já está cadastrado. Faça login ou use outro endereço.',
    INVALID_ACCOUNT_TYPE: 'Tipo de conta inválido. Selecione entre uso pessoal, autônomo, MEI ou empresa.',
    INVALID_CARDS: 'Escolha ao menos um módulo para continuar.',
    INVALID_CART_VALUES: 'Erro ao processar o carrinho. Atualize a página e tente novamente.',
    INVALID_EMAIL: 'E-mail inválido. Verifique o endereço informado e tente novamente.',
    INVALID_MONTHLY_VALUE: 'Valor mensal inválido. Verifique os dados do plano selecionado.',
    INVALID_PASSWORD_HASH: 'Não foi possível validar a senha. Tente criar a conta novamente.',
    INVALID_USERS_QTY: 'Quantidade de usuários inválida. Informe pelo menos 1 usuário.',
    RECORD: 'Encontramos os seguintes pontos de atenção:',
    SECURITY_PROVISIONING_RETRYABLE: 'Cadastro pendente de reconciliação de segurança.',
    BOARD_PROVISIONING_RETRYABLE: 'Cadastro pendente de disponibilização dos Boards. Tente novamente.'
  },
  explanation1: "Você pode testar 100% dos módulos por 60 dias gratuitamente, sem cartão de crédito.",
  explanation2: "Nosso sistema é composto por diversos módulos que podem ser combinados conforme a necessidade do seu negócio. Explore as opções e monte seu pacote, visualizando o valor mensal em tempo real.",
  explanation3: "- Uso pessoal e autônomo: 1 usuário fixo<br>- MEI: 3 usuários fixos<br>- Empresa: mínimo de 5 usuários",
  explanation4: "Demais usuários podem ser adicionados conforme a necessidade, com valores reduzidos para quantidades maiores.",
  explanation5: 'Explore todos os módulos disponíveis no Admin Digital. Aproveite o período de teste gratuito de 60 dias para conhecer todas as funcionalidades que podem transformar a gestão do seu negócio.',
  features: "Features:",
  howView: "Escolha como deseja visualizar os módulos.",
  included: "Já incluso",
  invalidEmail: 'Informe um e-mail válido',
  knowModules: "Descubra tudo que o<br>Admin Digital oferece",
  mandatoryModule: 'Selecionar pelo menos um módulo para continuar.',
  mei: 'MEI',
  moduleLabel1: 'Modulos (',
  moduleLabel2: '): R$ ',
  modulesLabel: 'Módulos',
  monthlyLabel1: 'Valor após 60 dias:',
  monthlyLabel2: 'R$ ',
  monthlyLabel3: '/mês',
  nickname: 'Como podemos te chamar?',
  personal: 'Uso pessoal',
  selectModule: "Selecionar módulo",
  selectedModule: "Módulo selecionado",
  selectSuite: "Selecionar suíte inteira",
  success1: 'Conta criada com sucesso!',
  success2: 'Enviamos um e-mail de confirmação de cadastro para',
  success3: 'Use este e-mail para acompanhar comunicados e alertas da sua conta.',
  successNoEmail: 'Conta criada com sucesso, mas não foi possível enviar o e-mail de confirmação agora.',
  activationMailSubject: 'Bem-vindo ao AdminDigital',
  activationMailText: 'Olá {name}!\nSeu cadastro foi concluído com sucesso e sua conta no AdminDigital já está pronta para uso!\n\nMódulos contratados:\n\n{modulesText}',
  activationMailHtml: '<p>Olá <strong>{name}</strong>!</p><p>Seu cadastro foi concluído com sucesso e sua conta no AdminDigital já está pronta para uso!</p><p><strong>Módulos contratados:</strong></p><ul>{modulesHtml}</ul>',
  activationMailModuleFallback: 'Módulo contratado',
  activationMailCustomerFallback: 'Cliente',
  userName: "Nome:",
  users: 'Usuários',
  usersLabel1: 'Usuários (',
  usersLabel2: '): R$ ',
  usersNum: 'Número de usuários',
  typeRegister: 'Tipo de cadastro',
  voidFields: 'Todos os campos precisam ser preenchidos',
  weakPassword1: 'Senha fraca detectada',
  weakPassword2: 'Uma senha fraca aumenta o risco de acesso não autorizado.',
  weakPassword3: '<span style="font-weight:bold;">Dica:</span> Para uma senha mais segura, use ao menos 8 caracteres, com letras maiúsculas, minúsculas, números e um símbolo.',
  weakPassword4: 'Deseja continuar mesmo assim?',
  weakPassword5: 'Não, quero alterar a senha',
  weakPassword6: 'Sim, manter a senha escolhida',
}
